import { render, staticRenderFns } from "./LeavesPastData.vue?vue&type=template&id=f87ae0bc"
import script from "./LeavesPastData.vue?vue&type=script&lang=js"
export * from "./LeavesPastData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports